export default __webpack_public_path__ + "static/media/feature_2@2x.a74cc8af.png";